<template>
  <el-table-column
    prop="nav_status"
    sortable="custom"
    label="NAV Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag
        v-for="status in statuses"
        :key="status.key"
        v-if="status.key === scope.row.nav_status"
        size="small"
        :type="status.tag"
        @click="openDialog(scope.row.nav_error)"
      >
        <i :class="status.icon"></i> {{ status.title }}
      </el-tag>
    </template>
    <el-dialog
      title="NAV hiba"
      :visible.sync="navDialogVisible"
      :append-to-body="true"
    >
        <pre
          style="white-space: pre-wrap; line-height: 1.5;"
        >
          {{ navError }}
        </pre>
    </el-dialog>
  </el-table-column>
</template>

<script>
export default {
  propName: 'nav_status',
  data() {
    return {
      navDialogVisible: false,
      navError: null,
      statuses: [
        {
          key: 'not-send',
          tag: 'info',
          title: 'Küldésre vár',
          icon: 'el-icon-loading',
        },
        {
          key: 'no-need',
          tag: 'info',
          title: 'Nem kell küldeni',
          icon: 'el-icon-remove-outline',
        },
        {
          key: 'processing',
          tag: 'info',
          title: 'Feldolgozás alatt',
          icon: 'el-icon-loading',
        },
        {
          key: 'sent-error',
          tag: 'danger',
          title: 'Elutasítva',
          icon: 'el-icon-error',
        },
        {
          key: 'aborted',
          tag: 'danger',
          title: 'Elutasítva',
          icon: 'el-icon-error',
        },
        {
          key: 'sent-success',
          tag: 'success',
          title: 'Elküldve',
          icon: 'el-icon-check',
        },
        {
          key: 'sent-warning',
          tag: 'warning',
          title: 'Elküldve hibával',
          icon: 'el-icon-warning',
        },
      ],
    };
  },
  methods: {
    openDialog(navError) {
      console.log(navError);
      if (navError) {
        this.navError = navError;
        this.navDialogVisible = true;
      }
    }
  },
};
</script>
